<template>
  <DialogContainer v-model="dialogObj" v-if="dialogObj.show">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item label="平台费用比例" prop="platformOpRate">
                <el-input
                  style="width: 100%"
                  v-model="form.platformOpRate"
                  clearable
                  autocomplete="off"
                  placeholder="请输入">
                  <span slot="append">%</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {editInfo, setAgentConfig} from "../api";
import { validatePrice } from "@/utils/validate";
export default {
  name: "DlsyyfConfigEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "设置加价比例",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        platformOpRate: "",
        companyId: "",
      },
      rules: {
        platformOpRate: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    init(row) {
      this.form.platformOpRate = row.platformOpRate;
      this.form.companyId = row.companyId;
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            companyId: this.form.companyId,
            platformOpRate: this.form.platformOpRate,
          };
          setAgentConfig(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("保存成功");
                this.$parent.handleAddOrEditSuccess(
                  this.form.companyId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .arrow-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrow-img {
    width: 0.24rem;
    height: 0.025rem;
    position: relative;
    top: 0.45rem;
  }
}
</style>
